import React from 'react';
import styled from 'styled-components';
import { string, func } from 'prop-types';

import { assetize } from '../../utils/pureUtils';

import Box from '../atoms/Box';
import Button from '../atoms/Button';
import Img from '../atoms/Img';
import Text from '../atoms/Text';
import htmlizeCarriageReturn from '../htmlizeCarriageReturn';

const StyledImg = styled(Img)(() => ({
  width: '100%'
}));

const StyledLines1 = styled('svg')(() => ({
  position: 'absolute',
  zIndex: -1,
  left: '-15%',
  top: '-30%',
  '@media (max-width: 768px)': {
    display: 'none'
  }
}));

const Lines1 = () => {
  return (
    <StyledLines1 width={285} height={320}>
      <g fill="#000" fillRule="evenodd">
        <path
          d="M94.715 70.8l.603.018c1 .045 1.998.173 2.994.39h185.4c1 0 .5 2.174-.2 2.174h-.3c-13.482.794-26.696.146-39.854.126l-41.386-.064c-36.574-.055-73.148-.06-109.72-.06-.677 0-1.365.107-2.04-.015a1.923 1.923 0 01-.146-.034c-.196-.06-.53-.126-.567-.818-.045-.835.354-1.19.584-1.268.311-.105.625-.035.937-.074.428-.053.855-.185 1.284-.24a17.986 17.986 0 013.014-.117zm215.897.197c.7 0-.2 2.172-.7 2.172h-17.1c-.7 0 .2-2.172.7-2.172z"
          transform="rotate(-40 200.182 72.288)"
        />
        <path
          d="M-24.192 202.05c31.577 0 63.31.8 94.887.8 35.976 0 71.794-.4 107.77-.8 35.19-.4 70.537 1.201 105.727.4 8.169 0 39.708-.478 41.002-.4 1.295.079 2.314-3.633-3.77-3.603-6.083.032-155.527.802-227.635.802-32.834 0-65.667.399-98.5-.802-11.94-.399-28.445-1.232-35.82 0-3.105.337-2.023 3.603-.313 3.603h16.652z"
          transform="rotate(-40 141.837 200.325)"
        />
      </g>
    </StyledLines1>
  );
};

const StyledLines2 = styled('svg')(() => ({
  position: 'absolute',
  zIndex: -1,
  right: '-18%',
  top: '7%',
  '@media (max-width: 768px)': {
    display: 'none'
  }
}));

const Lines2 = () => {
  return (
    <StyledLines2 width={406} height={341}>
      <g fill="#000" fillRule="evenodd">
        <path
          d="M-35.283 171.85c45.28 0 90.786.643 136.066.643 51.588 0 102.951-.322 154.54-.642 50.46-.321 101.148.963 151.61.32 11.714 0 56.94-.383 58.796-.32 1.857.063 3.319-2.914-5.406-2.89-8.723.026-223.023.643-326.424.643-47.083 0-94.165.32-141.248-.643-17.12-.32-40.788-.988-51.362 0-4.454.27-2.902 2.89-.451 2.89h23.88z"
          transform="rotate(-40 202.8 170.467)"
        />
        <path
          d="M103.466 202.894c.95.164 1.917.022 2.868.02 51.448 0 102.897.007 154.346.081 19.406.03 38.813.057 58.219.086 18.51.027 37.098.898 56.063-.17h.422c.985 0 1.688-2.921.282-2.921H114.86a26.158 26.158 0 00-4.212-.524 26.472 26.472 0 00-4.24.158c-.603.073-1.204.25-1.806.322-.439.052-.88-.042-1.318.1-.323.104-.885.581-.821 1.703.052.93.522 1.02.797 1.1.07.017.137.033.206.045"
          transform="rotate(-40 239.458 201.442)"
        />
      </g>
    </StyledLines2>
  );
};

const CtaSection = ({ title, desc, ctaLabel, onClick, dataCy }) => {
  return (
    <Box position="relative" width="100%" zIndex="1" overflow="hidden" py={10}>
      <Box
        maxWidth="1200px"
        display="flex"
        margin="auto"
        px={{ _: 4, md: 6, lg: 12 }}
        textAlign={{ _: 'center', md: 'left' }}>
        <Box flex="1">
          <Text mt={8} mb={3} tag="h2" styleName="pH1" fontSize="36px">
            {title}
          </Text>
          <Text styleName="wPBig" mb={4}>
            {htmlizeCarriageReturn(desc)}
          </Text>
          <Lines1 />
          <Lines2 />
          <Button mb={4} data-cy={dataCy} styleType="secondary" shape="rounded" onClick={onClick}>
            {ctaLabel}
          </Button>
        </Box>
        <Box flex="1" maxWidth="400px" display={{ _: 'none', md: 'block' }} pl={2}>
          <StyledImg alt="Beelance" src={assetize('/hire.webp')} fallback={assetize('/hire.png')} lazyloading={true} />
        </Box>
      </Box>
    </Box>
  );
};

CtaSection.propTypes = {
  title: string,
  desc: string,
  ctaLabel: string,
  onClick: func,
  dataCy: string
};

CtaSection.defaultProps = {
  title: '',
  desc: '',
  ctaLabel: '',
  onClick: () => null,
  dataCy: ''
};

export default CtaSection;
